import { Flex, media } from 'core/layout';

export const NewsList = Flex.withComponent('ul').extend`
  flex-wrap: wrap;
  list-style: none;
  margin-top: 0 !important;
  margin-bottom: 1.5em;
  padding-left: 0;
`;

export const MoreButtonGroup = Flex.extend`
  justify-content: center;

  ${media.tabletSmall`
    & > button {
      margin-top: 1em;
      width: 100%;
    }
  `};
`;



// WEBPACK FOOTER //
// ./src/modules/NewsSection/styled.js